import React from 'react';
import { Button, Typography, SvgIcon } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

interface GoogleLoginButtonProps {
  text?: string;
  variant?: 'text' | 'outlined' | 'contained';
  color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  fullWidth?: boolean;
  size?: 'small' | 'medium' | 'large';
}

/**
 * Przycisk logowania przez Google
 */
const GoogleLoginButton: React.FC<GoogleLoginButtonProps> = ({
  text = 'Zaloguj się przez Google',
  variant = 'contained',
  color = 'inherit',
  fullWidth = false,
  size = 'medium'
}) => {
  const [searchParams] = useSearchParams();
  const redirectParam = searchParams.get('redirect') || '/'

  // Adres URL do logowania przez Google (z przekazaniem redirect dla /cad itp.)
  const baseUrl = `${process.env.REACT_APP_API_URL || ''}/auth/google`;
  const googleAuthUrl = `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}redirect=${encodeURIComponent(redirectParam)}`;

  // Obsługa kliknięcia przycisku
  const handleLogin = () => {
    // Przekierowanie do strony logowania Google
    window.location.href = googleAuthUrl;
  };

  return (
    <Button
      variant={variant}
      color={color}
      fullWidth={fullWidth}
      size={size}
      onClick={handleLogin}
      startIcon={
        <SvgIcon>
          <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
            <path fill="#EA4335" d="M9 3.48c1.69 0 2.84.73 3.49 1.34l2.38-2.31C13.96.96 11.7 0 9 0 5.48 0 2.44 2.03.96 5.02l2.86 2.22C4.3 5.24 6.48 3.48 9 3.48z"/>
            <path fill="#4285F4" d="M17.64 9.2c0-.63-.06-1.25-.18-1.84H9v3.48h4.84c-.21 1.12-.84 2.07-1.79 2.71l2.73 2.12c1.6-1.48 2.86-3.67 2.86-6.47z"/>
            <path fill="#FBBC05" d="M3.86 10.24c-.2-.6-.31-1.24-.31-1.9s.11-1.3.31-1.9L1 4.02C.36 5.24 0 6.59 0 8.34s.36 3.1 1 4.32l2.86-2.42z"/>
            <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.17l-2.73-2.12c-.76.5-1.73.8-3.23.8-2.52 0-4.7-1.76-5.48-4.14L.96 12.98C2.44 15.97 5.48 18 9 18z"/>
          </svg>
        </SvgIcon>
      }
      sx={{
        borderRadius: 2,
        textTransform: 'none',
        fontWeight: 'bold',
        backgroundColor: '#F3F4F6',
        color: '#111827',
        border: '1px solid #E5E7EB',
        py: 1.2,
        boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
        '&:hover': {
          backgroundColor: '#E5E7EB',
          boxShadow: '0 2px 4px rgba(0,0,0,0.08)'
        }
      }}
    >
      <Typography variant={size === 'small' ? 'body2' : 'body1'} fontWeight="500">
        {text}
      </Typography>
    </Button>
  );
};

export default GoogleLoginButton;
